module.exports = __webpack_public_path__ + "img/oval.d8defa57.png";